module.exports = __webpack_public_path__ + "img/icon-step-scan.fcba73f6.png";